<template>
  <div>
    <AuthButtonLogin
      :only-login="onlyLogin"
    />
    <NavAccountSettings :only-login="onlyLogin" />
    <NavHelp :only-login="onlyLogin" />
  </div>
</template>

<script>
import NavHelp from '@/components/user/NavHelp';
import AuthButtonLogin from '@/components/user/UserAuthButtonLogin';
import NavAccountSettings from '@/components/user/UserNavAccountSettings';

import { mapActions } from 'vuex';

export default {
  name: 'UserNavAccount',

  components: {
    AuthButtonLogin,
    NavAccountSettings,
    NavHelp
  },

  props: {
    onlyLogin: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    accountLink() {
      return `${process.env.VUE_APP_SMAPSHOT_BACKOFFICE_URL}`;
    }
  },

  methods: {
    logout() {
      this.logout();
      this.$refs.paramsPopper.hide();
    },

    focusFormLogin() {
      this.$refs.loginFormContent.focusFirstElement();
    },

    ...mapActions('user', ['logout'])
  }
};
</script>

<style lang="postcss">
@media screen and (max-width:800px) {
  #label-help{
    @apply hidden;
  }
}
</style>
